<div class="phone-numbers-filter">
  <h5 class="filter-title">{{'PHONE_NUMBER' | translate}}</h5>
  <mat-form-field>
    <mat-label>
      <span *ngIf="!selectedMsisdnsForm.value.length" translate>PHONE_NUMBERS.HEADER</span>
    </mat-label>
    <mat-select #numbersSelector
                (selectionChange)="addFilter('channelsMsisdnsIds', $event.value)"
                multiple
                [formControl]="selectedMsisdnsForm"
    >
      <mat-select-trigger>
        <cc-flag-number-item *ngIf="selectedMsisdnsForm.value?.length"
                             [label]="displayedNumber.label"
                             [number]="displayedNumber.msisdn"
                             [empty]="'UNKNOWN'">
        </cc-flag-number-item>
        <div *ngIf="selectedMsisdnsForm.value?.length > 1" class="more-items-label">
          (+{{selectedMsisdnsForm.value.length - 1}})
        </div>
      </mat-select-trigger>
      <mat-checkbox
        class="phone-numbers-filter-option select-all"
        [(ngModel)]="allNumbersSelected"
        [(indeterminate)]="indeterminate"
        (change)="toggleAllNumbersSelect()">{{'SELECT_ALL' | translate}}</mat-checkbox>
      <mat-option *ngFor="let phoneNumber of msisdns"
                  [value]="phoneNumber.id"
                  class="phone-numbers-filter-option"
      >
        <cc-flag-number-item
          [label]="phoneNumber.label"
          [number]="phoneNumber.msisdn"
          [empty]="'UNKNOWN'">
        </cc-flag-number-item>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
